export default "__VITE_ASSET__6cb5aa33__"